var _path, _path2, _g, _path3, _path4, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeInsurance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 683,
    height: 683,
    viewBox: "0 0 683 683",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26044_751982)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.6666 192V66.6667H184V135.556",
    stroke: "white",
    strokeWidth: 26.6667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_26044_751982",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 683,
    height: 683
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.000610352H682.667V682.666H0V-0.000610352Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_26044_751982)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208 66.666H74.6666V13.3327H208V66.666Z",
    stroke: "white",
    strokeWidth: 26.6667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3333 302.943V669.332",
    stroke: "white",
    strokeWidth: 26.6667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.333 513.421V669.334",
    stroke: "white",
    strokeWidth: 26.6667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M597.333 305.335V393.42",
    stroke: "white",
    strokeWidth: 26.6667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_26044_751982",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 683,
    height: 683
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.000610352H682.667V682.666H0V-0.000610352Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_26044_751982)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.328 259.678L490.666 306.302V431.01C490.666 519.255 428.002 595.068 341.333 611.678C254.665 595.068 192 519.255 192 431.01V306.302L341.34 259.678",
    stroke: "white",
    strokeWidth: 26.6667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.333 345.524V431.01C245.333 490.111 285.129 541.53 341.333 556.963C397.537 541.53 437.333 490.111 437.333 431.01V345.524L341.333 315.552L245.333 345.524Z",
    stroke: "white",
    strokeWidth: 26.6667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.667 429.569L329.387 460.289L384 405.676",
    stroke: "white",
    strokeWidth: 26.6667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3334 669.332H633.333",
    stroke: "white",
    strokeWidth: 26.6667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.955 322.664L341.334 133.173L61.7122 322.664L13.3335 251.275L341.334 28.9988L669.334 251.275L620.955 322.664Z",
    stroke: "white",
    strokeWidth: 26.6667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26044_751982"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 682.667,
    height: 682.667,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeInsurance);
export default __webpack_public_path__ + "static/media/home-insurance.6202718cfa8c65242d2590f4800361d5.svg";
export { ForwardRef as ReactComponent };